import { ExpiredSessionError, ResponseError } from "src/utils";
import request from "../request";

export const uploadFile = async (
  file: File,
  documentCode: string,
  employeeId: number,
  fileName?: string,
): Promise<{ url: string }> => {
  const formData = new FormData();
  formData.append("file", file, fileName || file.name);
  formData.append("documentCode", documentCode);
  formData.append("employeeId", employeeId.toString());

  try {
    const { data } = await request.post(`/document-attachments`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (error) {
    if (error instanceof ExpiredSessionError) {
      throw error;
    } else {
      throw new ResponseError(error);
    }
  }
};

export const fetch = async (): Promise<RelDocument[]> => {
  try {
    const { data } = await request.get("/documents");
    return data;
  } catch (error) {
    if (error instanceof ExpiredSessionError) {
      throw error;
    } else {
      throw new ResponseError(error);
    }
  }
};
